module.exports = __webpack_public_path__ + "img/card-timeline-yuri.c52e34da.webp";